import React, {useRef, useState} from 'react';
import {NavLink} from 'react-router-dom';
import styles from './styles';
import {UserContext} from '../../Context/UserContext';
import {ResponsiveContext} from '../../Context/ResponsiveContext';
import { trackActivity } from '../../utils/activityTracker';
import {InstanceContext} from '../../InstanceContext';
import {InOutAnimation as Animation, Button} from '@xpertdox_js/xdcomponents';

const StyledNavLink = props => {
  const [hover, setHover] = useState(false);
  const hoverOn = () => setHover(true);
  const hoverOff = () => setHover(false);
  let linkStyles = hover
  ? {
    ...styles.subMenuItem,
    ...styles.subMenuItemHov
    }
  : styles.subMenuItem;
  let childProps = {
    style: linkStyles,
    onMouseEnter: hoverOn,
    onMouseLeave: hoverOff,
  }
  if (props.domLink) childProps.href = props.to
  else {
    childProps.to = props.to;
    hover &&  props.home && props.text === 'Home' ?
    childProps.activeStyle = {
      ...styles.subMenuItem,
      ...styles.subMenuItemHov
    } :
    childProps.activeStyle = {
      ...styles.subMenuItem,
      ...styles.subMenuItemActive,
    };

  }
  return React.createElement(
    props.domLink ? 'a' : NavLink,
    childProps,
    props.text
  )
}

const Header = props => {
  const pathName = props.history.location.pathname;
  const [width, setWidth] = React.useState(document.body.clientWidth - props.navSpacing + 'px')
  const spacingRef = useRef(props.navSpacing);
  if (props.navSpacing && spacingRef.current !== props.navSpacing) {
    spacingRef.current = props.navSpacing;
    setWidth(document.body.clientWidth - spacingRef.current + 'px');
  }
  const {user, userAction} = React.useContext(UserContext);
  const {contextInstance} = React.useContext(InstanceContext);
  const {resizeEvents, addResizeEvent, removeResizeEvent} = React.useContext(ResponsiveContext);
  const [hover, setHover] = useState(false);
  const [displayMenu, setDisplayMenu] = useState(false);

  // add resize event to context, remove on unmount
  React.useLayoutEffect(() => {
    addResizeEvent('headerResize', () => {
      setWidth(document.body.clientWidth - spacingRef.current + 'px');
    })
    return(() => removeResizeEvent('headerResize'))
  }, []);
  React.useLayoutEffect(() => {
    const calculatedValue = document.body.clientWidth - spacingRef.current + 'px';
    if (width !== calculatedValue) setWidth(calculatedValue);
  })

  //_id => {Component Name}.{Function Name}.{Function Params, If more than one or not a string make sure you STRINGIFY}
  const handleActivityLogUpdate = (_id) => {
    trackActivity({
      body: {
        _id,
        instance: contextInstance || user.instance,
        user: user.id
      }
    });
  }

  return(
    <div style={{
        ...styles.headerContainer,
        width: width,
        left: props.navSpacing + 'px',
      }}>
      <h1 style={styles.headerTitle}>
        {props.history.location.state
          ? props.history.location.state.title
          : (pathName === `/${props.instance}/` || pathName === `/${props.instance}`)
            ? 'XpertConsole'
            : ''
        }
      </h1>
      {props.dateUpdated && <div style={{
        ...styles.headerTitle,
        display: 'flex',
        float: 'left',
        color: 'rgb(44, 129, 210)',
        flexDirection: 'column',
        fontWeight: 700,
        fontSize: '1.1rem'
      }}>
        <span>DB Last Updated</span> <span>{props.dateUpdated}</span>
      </div>}
      {user.loggedIn &&
        <div style={styles.headerRight} onMouseEnter={() => {
            if (!displayMenu) setHover(true);
            setDisplayMenu(true);
          }} onMouseLeave={() => setHover(false)}>
          <svg style={styles.userIcon} xmlns="http://www.w3.org/2000/svg" viewBox='0 0 512 512'>
            <path d="M256 48C148.5 48 60.1 129.5 49.2 234.1c-.8 7.2-1.2 14.5-1.2 21.9 0 7.4.4 14.7 1.2 21.9C60.1 382.5 148.5 464 256 464c114.9 0 208-93.1 208-208S370.9 48 256 48zm135.8 326.1c-22.7-8.6-59.5-21.2-82.4-28-2.4-.7-2.7-.9-2.7-10.7 0-8.1 3.3-16.3 6.6-23.3 3.6-7.5 7.7-20.2 9.2-31.6 4.2-4.9 10-14.5 13.6-32.9 3.2-16.2 1.7-22.1-.4-27.6-.2-.6-.5-1.2-.6-1.7-.8-3.8.3-23.5 3.1-38.8 1.9-10.5-.5-32.8-14.9-51.3-9.1-11.7-26.6-26-58.5-28h-17.5c-31.4 2-48.8 16.3-58 28-14.5 18.5-16.9 40.8-15 51.3 2.8 15.3 3.9 35 3.1 38.8-.2.7-.4 1.2-.6 1.8-2.1 5.5-3.7 11.4-.4 27.6 3.7 18.4 9.4 28 13.6 32.9 1.5 11.4 5.7 24 9.2 31.6 2.6 5.5 3.8 13 3.8 23.6 0 9.9-.4 10-2.6 10.7-23.7 7-58.9 19.4-80 27.8C91.6 341.4 76 299.9 76 256c0-48.1 18.7-93.3 52.7-127.3S207.9 76 256 76c48.1 0 93.3 18.7 127.3 52.7S436 207.9 436 256c0 43.9-15.6 85.4-44.2 118.1z"/>
          </svg>
          <span style={styles.userName}>{user.name}</span>
          <svg style={styles.downIcon} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M256 294.1L383 167c9.4-9.4 24.6-9.4 33.9 0s9.3 24.6 0 34L273 345c-9.1 9.1-23.7 9.3-33.1.7L95 201.1c-4.7-4.7-7-10.9-7-17s2.3-12.3 7-17c9.4-9.4 24.6-9.4 33.9 0l127.1 127z"/></svg>
          {displayMenu &&
          <Animation
              animation={{
                in: [
                  ['opacity', {0: 0, 100: 1}, 120],
                  ['transform', {0: 180, 100: 0}, 280, {valueMap: 'rotateX($vdeg)', easing: 'easeOut'}]
                ],
                out: [
                  ['opacity', {0: 1, 100: 0}, 280],
                  ['transform', {0: 0, 100: 180}, 280, {valueMap: 'rotateX($vdeg)', easing: 'easeIn'}]
                ]
              }}
              condition={hover}
              wrapStyles={{...styles.subMenu, backfaceVisibility: 'hidden'}}
              callback={hover ? null : () => setDisplayMenu(false)}
          >
            <Button
                onClick={() => {handleActivityLogUpdate(`Header.userAction.(logout)`); userAction({type: 'logout', instance: props.instance});}}
                styles={styles.subMenuItem}
                hoverStyles={styles.subMenuItemHov}
            >
              Logout
            </Button>
            <StyledNavLink
                key='xt_console_home'
                to={{
                  pathname: '/' + props.instance,
                  state: {
                    title: 'XpertConsole',
                  }
                }}
                text='Home'
                home
            />
            <StyledNavLink
                key='xt_dashboard_link'
                to={'https://dashboard.xperttrial.com/' + (contextInstance || user.instance)}
                text='XpertDashboard'
                domLink
            />
          </Animation>
          }
        </div>
      }
    </div>
  )
}


export default Header;
